import DispenseAttemptsNotificationsContainer from './dispense-attempts-notifications-container';

export default DispenseAttemptsNotificationsContainer;
